import consentOne from "./consent-one";
import consentThree from "./consent-three";
import consentTwo from "./consent-two";

const steps = [...consentOne, ...consentTwo, ...consentThree];

export default steps;
